import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/ContactUs.css';
import '../css/about.css';

const IntegratedDrillingManagement
  = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
      const timer = setTimeout(() => {
        if (underlineRef.current) {
          underlineRef.current.classList.add('animate');
        }
      }, 50);

      return () => clearTimeout(timer);
    }, []);

    return (
      <>
        {/* Hero Section */}
        <div className="container-fluid about-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0, top: '-122px', paddingTop: '50px' }}>
          <div className="container about-content">
            <div className="row">
              <div className="col-lg-6 col-md-8 col-12 about-text">
                <h1 className="about-title text-white mt-5">Integrated Drilling Management Services</h1>
                <h2 className="about-subtitle">Petrochoice Integrated Services</h2>
                <div className="about-underline" ref={underlineRef}></div>
                <p className="about-desc text-white">Our integrated drilling management services are designed to cover the entire drilling lifecycle comprehensively. From initial well planning through to execution and the complete well delivery process, we offer a holistic approach to drilling operations. Leveraging our extensive expertise and state-of-the-art technologies, we ensure optimal performance and safety at every stage.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5 align-items-center">

              {/* Left Image Column */}
              <div className="col-lg-4">
                <img
                  src="/assets/integrated.jpg"
                  alt="Integrated Drilling"
                  className="img-fluid rounded shadow"
                />
              </div>

              {/* Right Text Column */}
              <div className="col-lg-8">
                <h3 className="fw-bold mb-3">Integrated Drilling Management</h3>
                <p className="mb-2">
                  We optimize drilling processes, enhance operational efficiency, and proactively mitigate risks.
                  Our highly experienced team excels in maintaining seamless coordination among various drilling disciplines,
                  ensuring the successful completion of projects.
                </p>
                <p className="mb-4">
                  Two categories of service are provided.
                </p>

                {/* Service Level Buttons */}
                <div className="row g-3">
                  <div className="col-md-6">
                    <Link className="btn btn-outline-primary w-100 py-3" to="/services/integrated-drilling/light-wims">
                      <i className="bi bi-gear-fill me-2"></i>
                      Level 1 - LD WIMS
                    </Link>
                  </div>
                  <div className="col-md-6">
                    <Link className="btn btn-outline-primary w-100 py-3" to="/services/integrated-drilling/fd-wms">
                      <i className="bi bi-gear-fill me-2"></i>
                      Level 2 - FD WMS
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  };

export default IntegratedDrillingManagement;
